import { runDemo } from "../shared/demoRunner";
import { createWCafeScene } from "./scene";

runDemo({ createScene: createWCafeScene });
